import loadjs from "loadjs"
import PropTypes from "prop-types"
import { useEffect } from "react"

import { reloadStamped, stampedJsUrl } from "helpers/external/stamped"

const StampedReviewsWidget = ({ stampedProductId, styleCode }) => {
  useEffect(() => {
    let timeout

    if (!loadjs.isDefined("stamped")) {
      loadjs(stampedJsUrl(), "stamped", {
        async: true,
        error: () => console.log("Error loading Stamepd"),
        success: () => (timeout = reloadStamped()),
      })
    } else {
      timeout = reloadStamped()
    }

    return () => clearTimeout(timeout)
  }, [])

  return (
    <div
      className="stamped-main-widget stamped-style-borderless"
      id="stamped-main-widget"
      {...(stampedProductId && {
        "data-product-id": stampedProductId,
        "data-product-sku": styleCode,
      })}
    />
  )
}

StampedReviewsWidget.propTypes = {
  stampedProductId: PropTypes.string,
  styleCode: PropTypes.string,
}

export default StampedReviewsWidget
